export default {
  salePrice: 'Sale price',
  dealPrice: 'Campaign price',
  standard: 'Standard registration',
  standardRules: 'Campaign rules apply',
  flexible: 'More flexible requirements',
  summary: 'The platform invites {count} SKUs to this campaign',
  total: '{count} SKUs total',
  product: 'Product',
  marketplaceProduct: 'Marketplace product',
  inventory: 'Inventory',
  registrationDetails: 'Registration details',
  priceRequirements: 'Registration price requirements',
  averagePrice: '30-day average transaction price',
  averagePriceHint: 'Average transaction price over the last 30 days; current sale price is used when there are no transactions.',
  remove: 'Remove product',
  emptySelection: 'All products were removed. Close this window and select products again.',
  selectedSummary: '{count} SKUs selected, including {invited} invited products',
  open: 'Registration is open',
  notOpen: 'Registration has not started',
  closed: 'Registration is closed',
  all: 'All products',
  invited: 'Invited products',
  tag: 'Campaign invitation',
  count: '{count} products invited to this campaign',
  homeNotice: '{products} invited to this campaign',
  productCount: '{count} product | {count} products',
  description: 'These products are doing,well, so we recommend that you join.this campaian.The reguirements are more flexible, and your campaign price must not be higher than the highest price shown.',
  suggestedPrice: 'Suggested activity price',
  maxRegistrationPrice: 'Maximum registration price',
  registrationPrice: 'Registration price',
  approvedPriceCap: 'Approved price limit',
  registrationType: 'Registration type',
  rejectionReason: 'Rejection reason',
  previousRejectionReason: 'Previous rejection reason',
  FREE: 'Free registration',
  STORE_WHITELIST: 'Store whitelist',
  INVITED: 'Invited product',
  positivePrice: 'Enter a positive whole-number price.',
  belowSalePrice: 'The price must be lower than the current sale price.',
  maximumPrice: 'Maximum allowed: {amount}',
  submitted: 'Submitted successfully. View the status in Manage Big Discount Sale Products.',
  partial: '{count} products succeeded. Only unsuccessful products remain.'
}
